import { __assign, __rest } from "tslib";
import React, { useContext } from 'react';
import classnames from 'classnames';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import s from './Separator.scss';
export var Breakpoint;
(function (Breakpoint) {
    Breakpoint[Breakpoint["Both"] = 0] = "Both";
    Breakpoint[Breakpoint["Desktop"] = 1] = "Desktop";
    Breakpoint[Breakpoint["Mobile"] = 2] = "Mobile";
})(Breakpoint || (Breakpoint = {}));
var Separator = function (_a) {
    var className = _a.className, _b = _a.forBreakpoint, forBreakpoint = _b === void 0 ? Breakpoint.Both : _b, rest = __rest(_a, ["className", "forBreakpoint"]);
    var isMobile = useContext(MobileContext);
    return (React.createElement("hr", __assign({ className: classnames(className, s['separator'], forBreakpoint === Breakpoint.Desktop && isMobile && s['hidden'], forBreakpoint === Breakpoint.Mobile && !isMobile && s['hidden']) }, rest)));
};
Separator.displayName = 'Separator';
export default Separator;
//# sourceMappingURL=Separator.js.map